// 引入方法
// 引入全局组件
import Cookies from 'js-cookie';
import customDatePicker from '@/components/customDatePicker';
import customColumn from '@/components/customColumn.vue';
import customTable from '@/components/customTable.vue';
import customTablePage from '@/components/customTablePage.vue';
import customPage from '@/components/customPage.vue';
import customDialog from '@/components/customDialog.vue';
import customDraw from '@/components/customDraw.vue';
import customSelect from '@/components/customSelect.vue';
import searchInput from '@/components/searchInput.vue';
import emptyTips from '@/components/emptyTips.vue';
import customTab from '@/components/customTab.vue';
import { switchButton, switchContainer } from '@/components/advancedSearch';
import imgDetailDialog from '@/components/imgDetailDialog.vue';
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
import common from './common.js';
import filters from './filters';


const components = {
  customDatePicker,
  customColumn,
  customTable,
  customTablePage,
  customPage,
  customDialog,
  customSelect,
  searchInput,
  customDraw,
  emptyTips,
  switchButton,
  switchContainer,
  imgDetailDialog,
  customTab,
  ElImageViewer
};

export default {
  install(Vue, store) {
    // Bus总线,可通过this.Bus.$emit()/this.Bus.$on()进行跨组件通讯 thsi.Bus.$off() 关闭监听
    const bus = new Vue();
    Vue.prototype.Bus = bus;
    // 切换语言清除标签
    const langCode = Cookies.get('langCode') || 'CN';
    const tagsLangCode = sessionStorage.getItem('tagsLangCode') || 'CN';
    if (langCode !== tagsLangCode) {
      sessionStorage.removeItem('tags');
      sessionStorage.removeItem('tagsLangCode');
    }
    // 模块动态注册
    store.registerModule('vm', {
      state: {
        tags: JSON.parse(sessionStorage.getItem('tags')) || [], // 标签数组
        tagsLangCode: sessionStorage.getItem('tagsLangCode') || 'CN', // 标签语种
        includeList: [], // 缓存路由
        hideSide: JSON.parse(sessionStorage.getItem('hideSide')) || false, // 影藏侧边栏
        aiChatVisible: false, // AI 对话面板是否显示
        aiChatMinimized: false, // AI 对话面板是否最小化
        aiChatMessages: [], // 当前会话消息列表
        aiChatStreaming: false, // 是否正在流式接收中
        aiChatSessions: [], // 当前页面生命周期内的历史会话
        aiChatSessionId: null, // 当前历史会话标识
      },
      mutations: {
        // 标签数组tags
        TAGS: (state, payload) => {
          state.tags = payload;
          state.tagsLangCode = Cookies.get('langCode') || 'CN';
          sessionStorage.tags = JSON.stringify(payload);
          sessionStorage.tagsLangCode = state.tagsLangCode;
        },
        // 缓存页面数组
        INCLUDELIST: (state, payload) => {
          state.includeList = payload;
        },
        // 侧边栏显示
        HIDESIDE: (state, payload) => {
          state.hideSide = payload;
          sessionStorage.hideSide = JSON.stringify(payload);
        },
        // AI 对话面板显示
        AI_CHAT_VISIBLE: (state, payload) => {
          state.aiChatVisible = payload;
        },
        // AI 对话面板最小化
        AI_CHAT_MINIMIZED: (state, payload) => {
          state.aiChatMinimized = payload;
        },
        // AI 消息列表
        AI_CHAT_MESSAGES: (state, payload) => {
          state.aiChatMessages = payload;
        },
        AI_CHAT_SESSIONS: (state, payload) => {
          state.aiChatSessions = payload;
        },
        AI_CHAT_SESSION_ID: (state, payload) => {
          state.aiChatSessionId = payload;
        },
        // AI 添加消息
        AI_CHAT_ADD_MESSAGE: (state, payload) => {
          state.aiChatMessages.push(payload);
        },
        // AI 更新最后一条消息（流式增量）
        // 用新对象替换最后一条，保证 Vue 2 能响应新增字段（如 progress）
        AI_CHAT_UPDATE_LAST_MESSAGE: (state, payload) => {
          const index = state.aiChatMessages.length - 1;
          if (index < 0) {
            return;
          }
          state.aiChatMessages.splice(index, 1, { ...state.aiChatMessages[index], ...payload });
        },
        // AI 流式状态
        AI_CHAT_STREAMING: (state, payload) => {
          state.aiChatStreaming = payload;
        },
      },
    });
    // 注册全局通用方法
    Object.keys(common).forEach((key) => {
      Vue.prototype[`$${key}`] = common[key];
    });
    // 注册全局filters
    Object.keys(filters).forEach((key) => {
      Vue.filter(key, filters[key]);
    });
    // 引入全局组件
    Object.keys(components).forEach((key) => {
      Vue.component(key, components[key]);
    });
  },
};
